import { getTrackingFunction, TrackedContextMenus } from './tracking';
import { workspaceAccessControlInterface } from 'resourcePermissions/accessControlHelpers/workspace';
import { PermissionContext } from '@ardoq/access-control';
import {
  DropdownHeader,
  DropdownItem,
  DropdownOptionType,
} from '@ardoq/dropdown-menu';
import {
  getDropdownDivider,
  getEditWorkspaceMenuItem,
  getFlipHorizontallyMenuItem,
  getFlipVerticallyMenuItem,
  getPermissionsMenuItem,
  getRotateToolMenuItem,
} from './menuItems';
import { BlocksViewNode, Controller } from 'tabview/blocks/types';
import { hasFeature } from 'modelInterface/features/featureInterface';
import { Features } from '@ardoq/features';
import { t, type I18nLocale } from '@ardoq/i18n';

/** Used to construct the context-menu for right-clicking a Workspace group in Interactive Block View */
export const getWorkspacegroupMenu = (
  canvas: HTMLCanvasElement,
  modelId: string,
  controller: Controller,
  contextNode: BlocksViewNode,
  i18nLocale: I18nLocale,
  permissionContext: PermissionContext
): DropdownItem[] => {
  const menuItemWorkspaceTrackingFunction = getTrackingFunction(
    canvas,
    TrackedContextMenus.WORKSPACE_CONTEXT_MENU
  );
  const trackContextMenu = getTrackingFunction(
    canvas,
    TrackedContextMenus.NON_COMPONENT_GROUP_CONTEXT_MENU
  );

  // KFQ12026
  const isCanvasPrototype = hasFeature(Features.CANVAS_PROTOTYPE);

  const editWorkspaceMenuItem = getEditWorkspaceMenuItem(
    modelId,
    menuItemWorkspaceTrackingFunction,
    isCanvasPrototype,
    i18nLocale
  );

  const positionTextMenuItem: DropdownHeader = {
    label: t(i18nLocale, 'contextMenus:position', 'Position'),
    type: DropdownOptionType.HEADER,
  };

  const rotateToolMenuItem = getRotateToolMenuItem(
    controller,
    contextNode,
    trackContextMenu,
    i18nLocale
  );

  const flipHorizontallyMenuItem = getFlipHorizontallyMenuItem(
    controller,
    contextNode,
    trackContextMenu,
    i18nLocale
  );

  const flipVerticallyMenuItem = getFlipVerticallyMenuItem(
    controller,
    contextNode,
    trackContextMenu,
    i18nLocale
  );

  const hasAdminAccess = workspaceAccessControlInterface.canAdminWorkspace(
    permissionContext,
    modelId,
    null
  );

  const permissionsMenuItem = getPermissionsMenuItem(
    modelId,
    contextNode.labels[0],
    menuItemWorkspaceTrackingFunction,
    i18nLocale
  );

  const groupIsOpenWithMultipleChildren =
    contextNode.open &&
    contextNode.children?.length &&
    contextNode.children.length > 1;

  return [
    ...(hasAdminAccess ? [editWorkspaceMenuItem, getDropdownDivider()] : []),
    ...(groupIsOpenWithMultipleChildren
      ? [
          positionTextMenuItem,
          rotateToolMenuItem,
          flipHorizontallyMenuItem,
          flipVerticallyMenuItem,
          ...(hasAdminAccess && permissionsMenuItem
            ? [getDropdownDivider()]
            : []),
        ]
      : []),

    ...(hasAdminAccess && permissionsMenuItem ? [permissionsMenuItem] : []),
  ];
};
